module.exports = __webpack_public_path__ + "images/fund-of-funds.png";